import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";

/**
 * Collapsible section header — Linear-style.
 */
export default function SectionHeader({ title, subtitle, action, children, defaultOpen = true, testid }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="space-y-4" data-testid={testid}>
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <button
          type="button"
          onClick={() => setOpen((o) => !o)}
          className="group flex items-center gap-2 text-left"
          data-testid={testid ? `${testid}-toggle` : undefined}
        >
          <ChevronDown
            className={cn(
              "h-4 w-4 text-muted-foreground transition-transform",
              !open && "-rotate-90",
            )}
          />
          <div>
            <h2 className="font-display text-lg sm:text-xl font-bold tracking-tight">{title}</h2>
            {subtitle && <p className="text-xs text-muted-foreground mt-0.5">{subtitle}</p>}
          </div>
        </button>
        {action}
      </div>
      {open && <div>{children}</div>}
    </section>
  );
}
